(function () {
  'use strict';
  if (customElements.get('dietz-halloween-wheel')) return;
  const core = globalThis.DietzHalloweenCore;
  if (!core) throw new Error('Carga dietz-wheel-core.js antes de la ruleta.');
  const scriptURL = document.currentScript.src;
  const defaultCSS = new URL('dietz-halloween-wheel.css', scriptURL).href;
  const logoURL = new URL('dietz-logo-white.png', scriptURL).href;
  const svg = (inside, className = '', viewBox = '0 0 24 24') => `<svg class="${className}" viewBox="${viewBox}" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">${inside}</svg>`;
  const icons = {
    arrow: '<path d="M4 12h15m-6-6 6 6-6 6"/>',
    sound: '<path d="M11 5 5 9H2v6h3l6 4V5Z"/><path d="M15 8a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14"/>',
    mute: '<path d="M11 5 5 9H2v6h3l6 4V5Z"/><path d="m16 9 6 6m0-6-6 6"/>',
    close: '<path d="m6 6 12 12M18 6 6 18"/>',
    copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M15 8V4H4v11h4"/>',
    star: '<path d="M12 1c1.3 7.3 3.7 9.7 11 11-7.3 1.3-9.7 3.7-11 11C10.7 15.7 8.3 13.3 1 12 8.3 10.7 10.7 8.3 12 1Z" fill="currentColor" stroke="none"/>',
    moon: '<path d="M19.5 15.4A8.8 8.8 0 0 1 8.6 4.5 9 9 0 1 0 19.5 15.4Z" fill="currentColor" stroke="none"/>',
    bat: '<path d="M2 2c1 6 2 8 7 6l2-4 1 2 1-2 2 4c5 2 6 0 7-6v16c-4-5-6-4-8 0l-2 4-2-4c-2-4-4-5-8 0Z" fill="currentColor" stroke="none"/>',
    ghost: '<path d="M5 20V9a7 7 0 0 1 14 0v11l-3-2-4 3-4-3-3 2Z" fill="var(--cream)"/><path d="M10 8v2m4-2v2"/>',
    garment: '<path d="M2 5c6 2 14 2 20 0v6c-5 1-7 4-8 9h-4c-1-5-3-8-8-9V5Z"/><path d="M2 8c6 2 14 2 20 0"/>',
    garments: '<path d="M2 3c5 2 12 2 17 0v5c-4 1-6 3-7 7H9C8 11 6 9 2 8V3Z"/><path d="M7 9c5 2 11 2 16 0v5c-4 1-6 3-7 7h-3c-1-4-3-6-6-7V9Z" fill="var(--sector-fill)"/>',
    percentage: '<path d="M4 4h16v5c-3 0-3 6 0 6v5H4v-5c3 0 3-6 0-6V4Z"/><path d="m9 16 6-8"/><circle cx="9" cy="8" r="1"/><circle cx="15" cy="16" r="1"/>',
    credit: '<ellipse cx="9" cy="5" rx="6" ry="3"/><path d="M3 5v4c0 4 12 4 12 0V5M3 9v4c0 3 7 4 11 2M3 13v4c0 2 4 3 7 3"/><ellipse cx="17" cy="15" rx="5" ry="2.5"/><path d="M12 15v4c0 3 10 3 10 0v-4"/>'
  };
  const designs = {
    dulce: { title: 'Un giro,<br> Muchos<br><em>Premios.</em>', colors: ['#fff1dc', '#bba3d5', '#2d202a', '#fff1dc', '#bba3d5', '#2d202a'], inks: ['#2d202a', '#2d202a', '#fff1dc', '#2d202a', '#2d202a', '#fff1dc'] },
    medianoche: { title: 'La suerte sale<br>de noche.', colors: ['#eee8dc', '#171619', '#353337', '#eee8dc', '#171619', '#353337'], inks: ['#171619', '#eee8dc', '#eee8dc', '#171619', '#eee8dc', '#eee8dc'] },
    ritual: { title: 'Tu próximo<br><em>flechazo</em><br>es un premio.', colors: ['#fff0e7', '#c7a7de', '#c1326f', '#fff0e7', '#c7a7de', '#c1326f'], inks: ['#382544', '#382544', '#fff0e7', '#382544', '#382544', '#fff0e7'] }
  };
  function point(degrees, radius) {
    return [300 + Math.cos(degrees * Math.PI / 180) * radius, 300 + Math.sin(degrees * Math.PI / 180) * radius];
  }
  function wheelMarkup() {
    const sectors = core.prizes.map((prize, index) => {
      const start = point(-120 + index * 60, 268);
      const end = point(-60 + index * 60, 268);
      const [x, y] = point(-90 + index * 60, 177);
      const icon = prize.kind === 'garment' ? (prize.amount === 1 ? 'garment' : 'garments') : prize.kind;
      return `<g data-prize="${prize.id}"><path class="sector" d="M300 300 L${start.join(' ')} A268 268 0 0 1 ${end.join(' ')}Z"/><g class="sector-label" transform="translate(${x} ${y})"><g class="prize-icon" transform="translate(-20 -34) scale(1.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${icons[icon]}</g><text x="0" y="29" text-anchor="middle">${prize.wheel}</text><path class="mini-star" d="M0 44 2 50 8 52 2 54 0 60-2 54-8 52-2 50Z"/></g></g>`;
    }).join('');
    let scallop = '';
    for (let i = 0; i <= 192; i++) {
      const angle = i / 192 * Math.PI * 2;
      const radius = 286 + Math.cos(angle * 24) * 4;
      scallop += `${i === 0 ? 'M' : 'L'}${300 + Math.cos(angle) * radius} ${300 + Math.sin(angle) * radius} `;
    }
    return `<svg class="wheel-svg" viewBox="0 0 600 600" role="img" aria-label="Ruleta con seis premios: prendas gratis, descuentos y un cupón de cien pesos mexicanos."><path class="scalloped-rim" d="${scallop}Z"/><circle class="outer-rim" cx="300" cy="300" r="284"/><circle class="inner-rim" cx="300" cy="300" r="276"/><g class="disc">${sectors}</g><circle class="hub" cx="300" cy="300" r="73"/><image href="${logoURL}" x="251" y="282" width="98" height="36" class="hub-logo"/><g class="pointer"><path class="pointer-shape" d="M281 8H319L300 58Z"/><path class="pointer-ritual" d="M300 0C263 0 281 33 300 58 319 33 337 0 300 0Z"/><path class="pointer-spark" d="M300 8 303 18 313 21 303 24 300 34 297 24 287 21 297 18Z"/></g></svg>`;
  }
  class DietzHalloweenWheel extends HTMLElement {
    static get observedAttributes() { return ['design', 'sound']; }
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this._rotation = 0;
      this._busy = false;
      this._sequence = 0;
      this._requestId = 0;
      this._ready = false;
    }
    get design() { return designs[this.getAttribute('design')] ? this.getAttribute('design') : 'dulce'; }
    get busy() { return this._busy; }
    get result() { return this._result || null; }
    connectedCallback() {
      if (!this._ready) this._render();
      this._resize = new ResizeObserver(entries => { this.toggleAttribute('compact', entries[0].contentRect.width < 1100); });
      this._resize.observe(this);
      globalThis.DietzHalloweenSession.configure(this.getAttribute('endpoint'));
      this._unsubscribe = globalThis.DietzHalloweenSession.subscribe(event => { if (!this._busy) this._acceptState(event.detail); });
      this._restoreClaim();
    }
    disconnectedCallback() {
      this._unsubscribe?.();
      this._resize?.disconnect();
      this._cancel();
      this._audio?.close().catch(() => {});
      this._audio = null;
      if (this._dialog?.open) this._dialog.close();
    }
    attributeChangedCallback(name) {
      if (!this._ready) return;
      if (name === 'design') this._updateDesign();
      if (name === 'sound') this._updateSound();
    }
    _render() {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = this.getAttribute('stylesheet-href') || defaultCSS;
      this.shadowRoot.append(css);
      const root = document.createElement('section');
      root.className = 'experience';
      root.setAttribute('aria-label', 'Ruleta de Halloween diëtz');
      root.innerHTML = `<div class="stage"><div class="intro"><div class="intro-art">${svg(icons.bat, 'intro-bat')}${svg(icons.star, 'intro-star')}</div><h1 class="title"></h1><p class="description">Prendas gratis, descuentos y $100 MXN.<br>Dale una vuelta a tu suerte.</p><div class="action-area"><div class="actions"><button class="spin" type="button"><span>Girar la ruleta</span>${svg(icons.arrow)}</button><button class="sound" type="button" aria-pressed="false" aria-label="Activar sonido">${svg(icons.mute)}</button></div><p class="status" role="status" aria-live="polite" aria-atomic="true"></p></div></div><div class="wheel-wrap">${svg(icons.star, 'decoration star-one')}${svg(icons.star, 'decoration star-two')}${svg(icons.star, 'decoration star-three')}${svg(icons.star, 'decoration star-four')}${svg(icons.moon, 'decoration moon')}${svg(icons.bat, 'decoration bat')}${svg(icons.ghost, 'decoration ghost-one')}${svg(icons.ghost, 'decoration ghost-two')}<div class="wheel-shell">${wheelMarkup()}</div><div class="confetti" aria-hidden="true"></div></div></div><dialog class="result-dialog" aria-labelledby="result-title" aria-describedby="result-note"><button class="close" type="button" aria-label="Cerrar resultado">${svg(icons.close)}</button><div class="result-art">${svg(icons.star)}</div><p class="result-kicker">Hoy la suerte es tuya.</p><h2 id="result-title"></h2><p class="result-detail"></p><div class="coupon"><code class="coupon-code"></code><button class="copy" type="button" aria-label="Copiar código de descuento">${svg(icons.copy)}</button></div><p id="result-note">Tu premio queda guardado en este navegador.</p><p class="copy-status" role="status" aria-live="polite"></p></dialog>`;
      this.shadowRoot.append(root);
      this._root = root;
      this._spinButton = root.querySelector('.spin');
      this._status = root.querySelector('.status');
      this._disc = root.querySelector('.disc');
      this._dialog = root.querySelector('dialog');
      this._spinButton.addEventListener('click', () => {
        if (this._claim) this._showClaim(this._claim);
        else this.spin();
      });
      root.querySelector('.sound').addEventListener('click', () => { this.toggleAttribute('sound'); });
      root.querySelector('.close').addEventListener('click', () => this._dialog.close());
      root.querySelector('.copy').setAttribute('aria-label', 'Copiar código de descuento');
      const conditions = document.createElement('p');
      conditions.className = 'conditions';
      conditions.textContent = 'Los regalos requieren al menos una prenda de pago en el mismo pedido. Premios no acumulables con otras promociones.';
      root.querySelector('.action-area').append(conditions);
      const redeem = document.createElement('a');
      redeem.className = 'redeem';
      redeem.textContent = 'Usar mi premio';
      root.querySelector('.result-dialog').append(redeem);
      const gift = document.createElement('form');
      gift.className = 'gift-form';
      gift.hidden = true;
      gift.innerHTML = '<label for="gift-size">Tu talla</label><select id="gift-size" required><option value="">Elige una talla</option><option>S</option><option>M</option><option>L</option><option>XL</option><option>2XL</option></select><button type="submit">Añadir mi regalo al carrito</button><p class="gift-status" role="status" aria-live="polite"></p>';
      root.querySelector('.result-dialog').append(gift);
      gift.addEventListener('submit', event => { event.preventDefault(); this._prepareGift(); });
      root.querySelector('.copy').addEventListener('click', () => this._copyCode());
      this._dialog.addEventListener('click', event => { if (event.target === this._dialog) { const box = this._dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this._dialog.close(); } });
      this._dialog.addEventListener('close', () => this._spinButton.focus({ preventScroll: true }));
      this._disc.addEventListener('transitionend', event => { if (event.target === this._disc && event.propertyName === 'transform') this._finish?.(); });
      this._ready = true;
      this._updateDesign();
      this._updateSound();
    }
    _updateDesign() {
      const design = designs[this.design];
      this._root.dataset.design = this.design;
      this._root.querySelector('.title').innerHTML = design.title;
      this._root.querySelectorAll('[data-prize]').forEach((group, index) => {
        group.style.setProperty('--sector-fill', design.colors[index]);
        group.querySelector('.sector').setAttribute('fill', design.colors[index]);
        group.querySelector('.sector-label').style.color = design.inks[index];
      });
    }
    _updateSound() {
      const on = this.hasAttribute('sound');
      const button = this._root.querySelector('.sound');
      button.setAttribute('aria-pressed', String(on));
      button.setAttribute('aria-label', on ? 'Desactivar sonido' : 'Activar sonido');
      button.innerHTML = svg(icons[on ? 'sound' : 'mute']);
    }
    _tone(frequency = 440, duration = 0.055) {
      if (!this.hasAttribute('sound')) return;
      try {
        const Audio = window.AudioContext || window.webkitAudioContext;
        if (!Audio) return;
        this._audio ||= new Audio();
        this._audio.resume().catch(() => {});
        const oscillator = this._audio.createOscillator();
        const gain = this._audio.createGain();
        const now = this._audio.currentTime;
        oscillator.type = 'sine';
        oscillator.frequency.value = frequency;
        gain.gain.setValueAtTime(0.018, now);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
        oscillator.connect(gain).connect(this._audio.destination);
        oscillator.start(now);
        oscillator.stop(now + duration);
      } catch (_) {}
    }
    _event(type, detail) { this.dispatchEvent(new CustomEvent(type, { detail, bubbles: true, composed: true })); }
    async _request(action, options = {}) {
      return globalThis.DietzHalloweenSession.request(action, options.body ? JSON.parse(options.body) : {});
    }
    _acceptState(data) {
      if (!this._ready || !this.isConnected) return;
      this._claim = data.claim;
      this.participation = { enabled: data.enabled, blocked: data.blocked, claim: data.claim };
      this._event('dietz:participation', this.participation);
      this._spinButton.querySelector('span').textContent = this._claim ? 'Ver mi premio' : data.blocked ? 'Ya participaste' : 'Girar la ruleta';
      this._spinButton.disabled = (!data.enabled || data.blocked) && !this._claim;
      this._status.textContent = this._claim ? 'Tu premio está guardado.' : data.blocked ? 'Esta conexión ya participó. Consulta tu premio desde el navegador en el que giraste.' : data.enabled ? '' : 'Estamos preparando la magia. Vuelve pronto.';
      if (this._claim) this._alignToClaim(this._claim);
    }
    _alignToClaim(claim) {
      const index = core.prizes.findIndex(prize => prize.id === claim.prizeId);
      if (index < 0) return;
      this._rotation = core.targetRotation(0, index, 0, 1) % 360;
      this._disc.style.transition = 'none';
      this._disc.style.transform = `rotate(${this._rotation}deg)`;
      this.dataset.selectedPrize = claim.prizeId;
    }
    async _restoreClaim() {
      const restoreId = this._restoreId = (this._restoreId || 0) + 1;
      this._spinButton.disabled = true;
      this._status.textContent = 'Comprobando tu participación…';
      try {
        const data = await globalThis.DietzHalloweenSession.status(true);
        if (!this.isConnected || restoreId !== this._restoreId) return;
        this._acceptState(data);
      } catch (_) {
        if (!this.isConnected || restoreId !== this._restoreId) return;
        this._spinButton.querySelector('span').textContent = 'Ruleta no disponible';
        this._spinButton.disabled = true;
        this._status.textContent = 'No pudimos comprobar tu participación. Inténtalo más tarde.';
      }
    }
    _showClaim(claim) {
      const prize = core.prizes.find(item => item.id === claim.prizeId);
      if (!prize) return;
      this._result = { prize, code: claim.code || null };
      this._root.querySelector('#result-title').textContent = prize.label;
      this._root.querySelector('.result-detail').textContent = prize.detail;
      const coupon = this._root.querySelector('.coupon');
      coupon.hidden = !claim.code;
      this._root.querySelector('.coupon-code').textContent = claim.code || '';
      this._root.querySelector('.copy-status').textContent = '';
      const redeem = this._root.querySelector('.redeem');
      const giftForm = this._root.querySelector('.gift-form');
      giftForm.hidden = true;
      redeem.hidden = claim.phase !== 'delivered';
      const note = this._root.querySelector('#result-note');
      if (claim.phase !== 'delivered') {
        note.textContent = 'Tu premio está reservado. Estamos confirmando su entrega; puedes consultar el estado desde esta página.';
      } else if (['credit', 'percentage'].includes(prize.kind)) {
        note.textContent = `${prize.kind === 'credit' ? 'Cupón de $100 MXN para una compra. ' : ''}Código de un solo uso, sin acumulación con otras promociones. Válido hasta el 31 de octubre de 2026.`;
        redeem.href = `/discount/${encodeURIComponent(claim.code)}?redirect=%2Fcollections%2Fall`;
        redeem.textContent = 'Usar mi cupón';
      } else {
        if (['ready', 'choose_size'].includes(claim.gift?.phase)) {
          note.textContent = 'Tu regalo sorpresa queda en el carrito. Para completar el pedido necesitas al menos una prenda de pago. Elige tu talla y el equipo preparará la sorpresa.';
          giftForm.hidden = false;
          giftForm.querySelector('select').disabled = claim.gift?.phase === 'ready';
          giftForm.querySelector('select').value = globalThis.DietzHalloweenCart?.size || claim.gift?.size || '';
          redeem.hidden = true;
          redeem.removeAttribute('href');
        } else {
          note.textContent = 'Estamos confirmando tu canje. Tu premio sigue guardado; consulta esta página más tarde.';
          redeem.hidden = true;
        }
      }
      if (!this._busy) this._alignToClaim(claim);
      if (!this._dialog.open) {
        this._dialog.showModal();
        const title = this._root.querySelector('#result-title');
        title.tabIndex = -1;
        title.focus({ preventScroll: true });
      }
    }
    async _prepareGift() {
      if (this._preparingGift) return;
      const form = this._root.querySelector('.gift-form');
      const select = form.querySelector('select');
      if (!select.value) return;
      this._preparingGift = true;
      const button = form.querySelector('button');
      button.disabled = true;
      select.disabled = true;
      form.querySelector('.gift-status').textContent = 'Añadiendo tu regalo…';
      try {
        await globalThis.DietzHalloweenCart.reserve(select.value);
        form.querySelector('.gift-status').textContent = 'Regalo añadido al carrito. Puedes seguir comprando.';
        button.textContent = 'Actualizar talla';
      } catch (_) {
        form.querySelector('.gift-status').textContent = 'No pudimos guardar el regalo en tu carrito. Tu premio sigue reservado; vuelve a intentarlo.';
      } finally {
        this._preparingGift = false;
        button.disabled = false;
        select.disabled = false;
      }
    }
    async spin() {
      if (this._busy || !this.isConnected) return false;
      if (this._claim) { this._showClaim(this._claim); return false; }
      this._busy = true;
      this._spinButton.disabled = true;
      this._spinButton.querySelector('span').textContent = 'Guardando tu giro…';
      let prize, claim;
      try {
        const state = await globalThis.DietzHalloweenSession.status(true);
        if (state.claim) { this._busy = false; this._acceptState(state); this._showClaim(state.claim); return false; }
        const data = await this._request('spin', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) });
        claim = data.claim;
        prize = core.prizes.find(item => item.id === claim?.prizeId);
        if (!prize) throw new Error('El premio seleccionado no existe.');
        this._claim = claim;
        if (data.replayed) { this._busy = false; this._acceptState(globalThis.DietzHalloweenSession.state); this._showClaim(claim); return false; }
      } catch (error) {
        this._busy = false;
        this._status.textContent = 'No pudimos confirmar el giro. Comprobaremos tu participación antes de intentarlo de nuevo.';
        await this._restoreClaim();
        return false;
      }
      if (!this.isConnected) { this._busy = false; return false; }
      if (this._dialog.open) this._dialog.close();
      const requestId = ++this._requestId;
      this._busy = true;
      this._spinButton.disabled = true;
      this._spinButton.querySelector('span').textContent = 'Un poquito de magia…';
      this._root.setAttribute('aria-busy', 'true');
      this._root.querySelector('.wheel-wrap').classList.remove('won');
      this._status.textContent = 'La ruleta está girando.';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration = reduced ? 100 : 4300;
      const index = core.prizes.indexOf(prize);
      const offset = 0;
      this._rotation = core.targetRotation(this._rotation, index, offset, 6);
      this._disc.style.transition = `transform ${duration}ms cubic-bezier(.12,.72,.12,1)`;
      this._disc.style.transform = `rotate(${this._rotation}deg)`;
      this._event('dietz:spin-start', { design: this.design });
      this._tone(330, 0.09);
      const started = performance.now();
      let lastTick = 0;
      const tick = now => {
        if (!this._busy || requestId !== this._requestId) return;
        const progress = Math.min((now - started) / duration, 1);
        const interval = 45 + Math.pow(progress, 3) * 350;
        if (now - lastTick > interval) { this._tone(540 + progress * 80); lastTick = now; }
        if (progress < 1) this._raf = requestAnimationFrame(tick);
      };
      if (this.hasAttribute('sound') && !reduced) this._raf = requestAnimationFrame(tick);
      this._finish = () => {
        if (!this._busy || requestId !== this._requestId || !this.isConnected) return;
        clearTimeout(this._timer);
        cancelAnimationFrame(this._raf);
        this._finish = null;
        this._busy = false;
        this._acceptState(globalThis.DietzHalloweenSession.state);
        this._sequence += 1;
        this._result = Object.freeze({ prize, code: claim.code || null, design: this.design, rotation: this._rotation });
        this._spinButton.disabled = false;
        this._spinButton.querySelector('span').textContent = 'Ver mi premio';
        this._root.removeAttribute('aria-busy');
        this._status.textContent = `Te ha tocado ${prize.label}. Tu premio está guardado.`;
        this._root.querySelector('#result-title').textContent = prize.label;
        this._root.querySelector('.result-detail').textContent = prize.detail;
        this._root.querySelector('.coupon-code').textContent = this._result.code;
        this._root.querySelector('.copy-status').textContent = '';
        this._root.querySelector('.wheel-wrap').classList.add('won');
        this._showClaim(claim);
        this._tone(740, 0.18);
        if (!reduced) this._celebrate();
        this._event('dietz:spin-result', this._result);
      };
      this._timer = setTimeout(() => this._finish?.(), duration + 120);
      return true;
    }
    _celebrate() {
      const layer = this._root.querySelector('.confetti');
      layer.replaceChildren();
      for (let i = 0; i < 24; i++) {
        const bit = document.createElement('i');
        bit.style.cssText = `--x:${(i * 73 % 240) - 120}px;--r:${i * 37}deg;--delay:${i % 5 * 30}ms;left:${15 + (i * 41 % 70)}%;background:${designs[this.design].colors[i % 6]};`;
        layer.append(bit);
      }
    }
    async _copyCode() {
      if (!this._result?.code) return;
      const status = this._root.querySelector('.copy-status');
      try { await navigator.clipboard.writeText(this._result.code); status.textContent = 'Código copiado.'; }
      catch (_) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this._root.querySelector('.coupon-code'));
        selection.removeAllRanges(); selection.addRange(range);
        status.textContent = 'Código seleccionado. Cópialo con el menú de tu dispositivo.';
      }
    }
    _cancel() {
      ++this._requestId;
      clearTimeout(this._timer);
      cancelAnimationFrame(this._raf);
      this._finish = null;
      this._busy = false;
      if (this._spinButton) {
        this._spinButton.disabled = false;
        this._spinButton.querySelector('span').textContent = 'Girar la ruleta';
        this._root.removeAttribute('aria-busy');
      }
    }
    reset() {
      return false;
    }
  }
  customElements.define('dietz-halloween-wheel', DietzHalloweenWheel);
})();
